import { IconProps } from "../../utils/global-types/global-types";

const DeleteModalityIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    fill="none"
    viewBox="0 0 18 18"
    className={className}
    {...rest}
  >
    <path
      fill="#EE8C8B"
      fillOpacity="0.1"
      d="M0 9a9 9 0 1 1 18 0A9 9 0 0 1 0 9"
    ></path>
    <g fill="#E13F41" clipPath="url(#clip0_5379_99997)">
      <path d="M12.753 7.21H8.128L10.2 5.14a.293.293 0 0 0 0-.415L9.675 4.2a.684.684 0 0 0-.967 0l-.54.54-.276-.276a.78.78 0 0 0-1.105 0L5.71 5.54a.78.78 0 0 0 0 1.105l.276.276-.54.54a.684.684 0 0 0 0 .966l.525.525c.115.115.3.115.414 0l.743-.742v4.52c0 .7.568 1.269 1.27 1.269h3.086a1.27 1.27 0 0 0 1.27-1.27zM6.4 6.509l-.276-.277a.196.196 0 0 1 0-.276l1.077-1.077a.196.196 0 0 1 .277 0l.276.276zm2.53 5.851a.293.293 0 1 1-.586 0V8.851a.293.293 0 1 1 .586 0zm1.304 0a.293.293 0 1 1-.586 0V8.851a.293.293 0 1 1 .586 0zm1.303 0a.293.293 0 1 1-.586 0V8.851a.293.293 0 0 1 .586 0z"></path>
      <path d="M10.267 6.218a.49.49 0 0 0-.325.407h2.812v-.487a.49.49 0 0 0-.646-.463l-1.835.54z"></path>
    </g>
    <defs>
      <clipPath id="clip0_5379_99997">
        <path fill="#fff" d="M4 4h10v10H4z"></path>
      </clipPath>
    </defs>
  </svg>
);

export default DeleteModalityIcon;
